import i18next from 'i18next';

i18next.addResources('es_CL', 'RutPapaPoints', {
  title: 'Completa tu perfil para acceder al catálogo de Papa Puntos',
  description:
    'Tus puntos están esperando. Ingresa tu RUT y accede al catálogo de Papa Puntos con productos, descuentos y recompensas pensadas para ti. ',
  save: 'Guardar y continuar',
  notNow: 'Ahora no',
  rut: 'RUT',
  errorUpdate: 'Parece que el RUT no es correcto. Revísalo e intenta nuevamente.',
  terms: 'Revisa aquí los ',
  errorUpdateTaken: 'Ya existe una cuenta asociada a este RUT. <Link>{{text}}</Link> si necesitas ayuda.',
  clickHere: 'Haz click aquí'
});
